import PlansSummary from './PlansSummary';

export default PlansSummary;
